import { render, staticRenderFns } from "./En_topper.vue?vue&type=template&id=08704dd0"
import script from "./En_topper.vue?vue&type=script&lang=js"
export * from "./En_topper.vue?vue&type=script&lang=js"
import style0 from "./En_topper.vue?vue&type=style&index=0&id=08704dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports